import editSessionApi from '@/api/order/edit-session'

const state = {
    showCorrectionReceiptDialog: false,
    allowExitWithoutChekingChanges: false,
    checkingBasketItemsChanges: false,
    closing: false,
    nextRoute: null,
}

const mutations = {
    setShowCorrectionReceiptDialog (state, value) {
      state.showCorrectionReceiptDialog = value
    },
    setAllowExitWithoutChekingChanges (state, value) {
      state.allowExitWithoutChekingChanges = value
    },
    setCheckingBasketItemsChanges (state, value) {
      state.checkingBasketItemsChanges = value
    },
    setClosing (state, value) {
      state.closing = value
    },
    setNextRoute (state, value) {
      state.nextRoute = value
    },
}

const actions = {
      async close ({ commit }, orderId) {
        commit('setClosing', true)
        try {
          await editSessionApi.close(orderId)
          commit('setShowCorrectionReceiptDialog', false)
        } finally {
          commit('setClosing', false)
        }
      },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
